import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Confirmation() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "confirmation" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="alert-circle" size={30} color="#DC2626" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                {modal.buttons ? (
                  <>
                    {modal.buttons.map((button, index) => {
                      return (
                        <button
                          className={
                            index === modal.buttons.length - 1
                              ? styles.save
                              : styles.cancel
                          }
                          onClick={() => button.action()}
                        >
                          {button.label}
                        </button>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <button
                      className={styles.cancel}
                      onClick={() => setModal("")}
                    >
                      Cancel
                    </button>
                    <button
                      className={styles.save}
                      onClick={() => modal.action()}
                    >
                      Confirm
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
